import { Button, Modal } from 'antd';
import { t } from 'i18next';
import IconError from '../../../assets/Images/icons/icon-error';

const Modal500 = ({
    open,
    text = 'Unable to connect to the server, please try again.',
    handelClose,
}) => {
    return (
        <Modal
            width={450}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <div className="flex flex-col space-y-4 justify-center items-center py-6">
                <IconError />
                <div className="text-2xl font-semibold">
                    {t('common.ErrorCode500')}
                </div>
                <div>{text}</div>
            </div>
            <div className="flex justify-center items-center space-x-4">
                <Button onClick={handelClose} size="large" type="primary">
                    {t('common.TryAgain')}
                </Button>
            </div>
        </Modal>
    );
};
export default Modal500;
